if (!Object.hasOwn) {
  Object.hasOwn = (object: object, property: PropertyKey): boolean =>
    Object.prototype.hasOwnProperty.call(object, property);
}